import type React from "react";

const MIDDLE_BUTTON = 1;

// Links inside the row keep the browser's native middle-click behaviour.
const isInsideLink = (target: EventTarget) =>
  target instanceof Element && target.closest("a") !== null;

/**
 * Props for a clickable table row so a middle click opens `url` in a new tab,
 * like a real link. onMouseDown cancels the browser's autoscroll cursor.
 */
export const middleClickOpen = (url: string) => ({
  onMouseDown: (e: React.MouseEvent) => {
    if (e.button === MIDDLE_BUTTON && !isInsideLink(e.target))
      e.preventDefault();
  },
  onAuxClick: (e: React.MouseEvent) => {
    if (e.button !== MIDDLE_BUTTON || isInsideLink(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    window.open(url, "_blank", "noopener");
  },
});
